import { getChannelAPIPath } from '@treasury/core/http';

CentrixSsoService.$inject = ['$resource', '$q', '$http'];

export default function CentrixSsoService($resource, $q, $http) {
    return {
        getCentrixSsoLogin,
    };

    function getCentrixSsoLogin() {
        return $resource(
            `${getChannelAPIPath()}arp/getCentrixSsoLogin`,
            {},
            { get: { method: 'GET', isArray: false } }
        ).get().$promise;
    }
}
